import { useCurrentSurvey } from "@pulse/hooks/surveyHooks";
import { useTranslation } from "react-i18next";

export function TitleDisplay() {
    const { data } = useCurrentSurvey();
    const { t } = useTranslation();
    const anonymityText = `This survey is completely anonymous.

We do not collect names, email addresses, IP addresses, or any other information that can identify respondents. It is therefore not technically possible to see who has completed the survey or who gave a particular answer.

Results will only be reviewed in aggregated form.`;
    return (
        <div className="flex flex-col gap-5">
            <h1 className="text-h1 text-start font-medium min-w-0 wrap-anywhere">{data.title}</h1>

            {data.description ? (
                <p className="text-compendia-muted text-start text-base font-light whitespace-pre-wrap min-w-0 wrap-anywhere">
                    {data.description}
                </p>
            ) : (
                <p className="text-compendia-muted/70 text-start text-base font-light whitespace-pre-wrap">
                    {t("survey.addDescription") + "..."}
                </p>
            )}
            <p className="text-start text-xl whitespace-pre-wrap">{anonymityText}</p>
        </div>
    );
}
